<template>
  <div class="menu-container">
    <div class="menu-item" @change="$emit('updateImage', $event)">
      <input class="photo-input" type="file" accept="image/*" title />
      {{ $t("ChangePhoto") }}
    </div>
    <div class="menu-item" @click="$emit('removeImage')">
      {{ $t("DeletePhoto") }}
    </div>
  </div>
</template>

<script>
export default {
  name: "PhotoMenu"
};
</script>

<style scoped>
.menu-container {
  background-color: var(--main-white);
  box-shadow: 0 2px 10px 5px rgba(0, 0, 0, 0.3);
}
.menu-item {
  padding: 6px 10px 6px 6px;
  font-size: 8px;
  color: var(--primary-normal);
}
.menu-item:hover {
  color: var(--primary-highlight);
  background: #f1f1f1;
}
.photo-input {
  position: absolute;
  opacity: 0;
  width: 50px;
  height: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Photos/PhotoMenu.vue